import cookies from 'js-cookie';
import React, { Fragment, useContext, useEffect } from 'react';
import { Helmet as HeaderMeta } from 'react-helmet';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LocaleContext } from 'shared';
import { getEnvironmentVar, setSecureCookie } from 'utils';

import { ActivateEmailContainer } from './activateEmail/ActivateEmailContainer';
import { Authorization } from './authorization/Authorization';
import { ChangePasswordContainer } from './changePassword/ChangePasswordContainer';
import { DashboardContainer } from './dashboard/DashboardContainer';
import { LogoutContainer } from './logout/LogoutContainer';

export const App = () => {
  const localeContext = useContext(LocaleContext);

  useEffect(() => {
    if (!cookies.get('locale')) {
      setSecureCookie('locale', 'en');
    }
  }, []);

  return (
    <Router basename={getEnvironmentVar('PUBLIC_URL')}>
      <Fragment>
        <HeaderMeta>
          <title>{localeContext.formatMessage({ id: 'GENERAL.TITLE' })}</title>
        </HeaderMeta>

        <Switch>
          <Route path="/login" component={Authorization} exact={true} />
          <Route path="/reset/:token" exact={true} component={ChangePasswordContainer} />
          <Route path="/activate/:token" exact={true} component={ActivateEmailContainer} />
          <Route path="/logout" component={LogoutContainer} exact={true} />
          <Route path="/" component={DashboardContainer} />
        </Switch>
      </Fragment>
    </Router>
  );
};
